import {IIndividualWinPresentationConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {BetLineWinIndividualWPController} from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {RomanEmpireEvents} from "../../events/RomanEmpireEvents";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Timeline, TimelineLite, TweenLite} from "gsap";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {RomanEmpireGameConfig} from "../../RomanEmpireGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {IShineMask} from "../betline/RomanEmpirePolyBetLine";
import {LineShine, LineShineMask} from "../betline/LineSprite";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {IBetLineBothWayWinData, RomanEmpireParsedGameData} from "../../server/data/RomanEmpireParsedGameData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {ScatterAnimationView} from "../../scatteranimation/ScatterAnimationView";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {RomanEmpireGameModuleConfig} from "../../RomanEmpireGameModuleConfig";
import {RomanEmpireReelSymbol} from "../../symbols/RomanEmpireReelSymbol";
import {ISymbolPositions} from "../geniefeature/GenieFeatureController";

export class REBetLineWinIndividualWPController extends BetLineWinIndividualWPController {
    private readonly _scatterAnimContainer: PIXI.Container;
    private betIndex: number;
    private _lineShine: PIXI.Sprite;
    private _betLineMask: PIXI.Sprite;
    private _isShinePlaying: boolean;
    private readonly _lineShineMaskMap: Map<number, IShineMask> = new Map();

    constructor(config: IIndividualWinPresentationConfig, name?: string, tweakEnabled?: boolean) {
        super(config, name, tweakEnabled);
        this._scatterAnimContainer = new PIXI.Container();
    }

    protected addFeatureEventHandlers(): void {
        EventHandler.addEventListener(this, RomanEmpireEvents.ON_LINE_SHINE_MASK_CREATED, (event: GameEvent) => this.onLineShineMaskCreated(event.params[0], event.params[1]));
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, () => {
            this._scatterAnimContainer.removeChildren()
            RomanEmpireReelSymbol._isIdleAnimation = false;
        });
    }

    /**
     * Override parent class function to add new events.
     * @param betLineWinData
     */
    protected getLineAnimation(betLineWinData: IBetLineBothWayWinData): Timeline {
        //const timeline: TimelineLite = new TimelineLite();
        const timeline: TimelineLite = new TimelineLite({
            onComplete: () => {
                if (this._lineShine) {
                    this._lineShine.visible = false;
                }
                StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).removeChild(this._lineShine);
            }
        });
        timeline.add(() => {
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SHOW_WIN_BET_LINE, betLineWinData.betLineIndex + 1, true));
            //params added  isIndividual = true;
            EventHandler.dispatchEvent(new GameEvent(RomanEmpireEvents.SHOW_WIN_BET_LINE_WIN_AMOUNT, (this._gameData as RomanEmpireParsedGameData).isGenieFeatureTriggered, betLineWinData, true));
            TweenLite.delayedCall(0.4,()=>(this._gameData as RomanEmpireParsedGameData).isRandomBothWaysTriggered && this.hasWin() && RomanEmpireGameModuleConfig.foregroundAnimation.playExpandWildAnimation(true));
        });

        if (betLineWinData.lineStart === "Right") {
            for (let i: number = betLineWinData.betLine.length - 1; i >= betLineWinData.betLine.length - betLineWinData.nrOfSymbols; i--) {
                const symbol = Reels.getSymbol(i, betLineWinData.betLine[i]);
                if (symbol) {
                    this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, this._config.symbolTimeOffsetCalculator(timeline.totalDuration(), i, betLineWinData.betLine[i]), symbol, i, betLineWinData.betLine[i]);
                    if (this._winSymbols.indexOf(symbol) === -1) {
                        this._winSymbols.push(symbol);
                    }
                }
            }
        } else {
            for (let i: number = 0; i < betLineWinData.nrOfSymbols; i++) {
                const symbol = Reels.getSymbol(i, betLineWinData.betLine[i]);
                if (symbol) {
                    this.addSymbolWinAnimationToTimeline(betLineWinData, timeline, this._config.symbolTimeOffsetCalculator(timeline.totalDuration(), i, betLineWinData.betLine[i]), symbol, i, betLineWinData.betLine[i]);
                    if (this._winSymbols.indexOf(symbol) === -1) {
                        this._winSymbols.push(symbol);
                    }
                }
            }
        }
        this.getBetLinePos(betLineWinData, timeline);
        return timeline;
    }


    private getScatterSprite(textureStr: string, position?: ISymbolPositions): TimelineSprite {
        const textures: PIXI.Texture[] = GameResources.getTextures(textureStr);
        const sprite: TimelineSprite = new TimelineSprite(textures, 30);
        sprite.anchor.set(0.5, 0.5);
        if (position) {
            const pos = Helper.getSymbolPositions(position.reelId, position.symbolId);
            sprite.position.set(pos[0], pos[1]);
        }
        return sprite;
    }

    /**
     * function to create scatter animation for initial win
     * @param reelId
     * @param symId
     */
    private scatterInitialWinAnimation(reelId: number, symId: number): TimelineSprite {
        const scatterAnticipationAnim = this.getScatterSprite("scatterAnticipationIdle", {
            reelId: reelId,
            symbolId: symId
        });
        this._scatterAnimContainer.addChild(scatterAnticipationAnim);
        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.SYMBOLS.name).addChild(this._scatterAnimContainer);
        return scatterAnticipationAnim;
    }

    //if randomBothWay triggered skip 2nd and 4th reel symbol anim
    private isSkipSymbolAnimFor2ndAnd4thReel(reelId: number): boolean {
        return (this._gameData as RomanEmpireParsedGameData).isRandomBothWaysTriggered && (reelId == 1 || reelId == 3);
    }

    protected addSymbolWinAnimationToTimeline(betLineWinData: IBetLineWinData, timeline: gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax, startTime: number, symbol: StateReelSymbol, reelId: number, symbolId: number): void {
        RomanEmpireReelSymbol._isIdleAnimation = false;
        if (symbol.symName === "S") { // added this to play scatter animation on individual win
            let anim = this.scatterInitialWinAnimation(reelId, symbolId);
            timeline.add(() => {
                anim.getAnimationAutoShowHide(true, false);
            }, startTime);
        } else {
            timeline.add(() => this.sortSymbolDepthToTop(symbol), startTime);
            if(!this.isSkipSymbolAnimFor2ndAnd4thReel(reelId)){
                timeline.add(symbol.changeState({
                    state: RomanEmpireGameConfig.instance.SYMBOL_STATES.initialWin,
                    fadeInDuration: 2,
                }), startTime);
            }
        }
    }

    protected stopWinPresentation(isAborted: boolean): void {
        if (this._isShinePlaying) {
            this._lineShine.visible = false;
        }
        if (this._lineShine) {
            StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).removeChild(this._lineShine);
            StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).removeChild(this._betLineMask);
        }
        super.stopWinPresentation(isAborted);
    }

    /**
     * To add a mask position in Bet line shin mask map.
     * @param index
     * @param mask
     */
    private onLineShineMaskCreated(index: number, mask: IShineMask) {
        this._lineShineMaskMap.set(index, mask);
    }

    /**
     * function to get individual line positions
     */
    private getBetLinePos(betLineData: IBetLineBothWayWinData, timeline: gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax): void {
        const linePositions: number[][] = [];
        this.betIndex = betLineData.betLineIndex + 1;
        for (let j: number = 0; j < betLineData.betLine.length; j++) {
            const basePosition: number[] = Helper.getSymbolPositions(j, betLineData.betLine[j]);
            linePositions.push(basePosition);
        }
        this.playShineAnimaitonOnBetLines(linePositions, timeline, betLineData.lineStart);
    }


    /**
     * To play winning bet lines shine animation.
     * @param linepos
     * @param timeline
     */
    private playShineAnimaitonOnBetLines(linepos: number[][], timeline: gsap.SimpleTimeline | gsap.TimelineLite | gsap.TimelineMax, lineStart: string): void {
        if (this._lineShine) {
            StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).removeChild(this._lineShine);
            StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).removeChild(this._betLineMask);
        }
        linepos.unshift([linepos[0][0] - 150, linepos[0][1]]);
        linepos.push([linepos[linepos.length - 1][0] + 150, linepos[linepos.length - 1][1]]);
        this._lineShine = new LineShine();

        const shineMaskPos: IShineMask | undefined = this._lineShineMaskMap.get(this.betIndex);
        if (shineMaskPos) {
            this._betLineMask = new LineShineMask(GameResources.getTextures(shineMaskPos.textureStr)[0], shineMaskPos);
            this._lineShine.mask = this._betLineMask;
            this._betLineMask = this._betLineMask;
            StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).addChild(this._betLineMask);
        } else {
            debugger;
            Logger.warn("mask data not found in ShineMaskMap for individual bet line  index : ", this.betIndex);
        }
        this._isShinePlaying = true;
        this._lineShine.width = this._lineShine.width + 150;
        this._lineShine.height = this._lineShine.height + 800;


        StageManager.getLayer(RomanEmpireGameConfig.instance.LAYERS.BET_LINES.name).addChildAt(this._lineShine, RomanEmpireGameConfig.instance.TOTAL_BET_LINES);
        if (lineStart === "Right") {
            this._lineShine.position.set(linepos[linepos.length - 1][0], linepos[linepos.length - 1][1]);
            timeline.add(() => {
                TweenLite.fromTo(this._lineShine, 0.5, {
                    x: linepos[linepos.length - 1][0],
                    y: linepos[linepos.length - 1][1]
                }, {x: linepos[0][0], y: linepos[0][1]});
            }, 0.5);
        } else {
            this._lineShine.position.set(linepos[0][0], linepos[0][1]);
            timeline.add(() => {
                TweenLite.fromTo(this._lineShine, 0.5, {
                    x: linepos[0][0],
                    y: linepos[0][1]
                }, {x: linepos[linepos.length - 1][0], y: linepos[linepos.length - 1][1]});
            }, 0.5);
        }
    }

    protected parseFeatureGameData(data: RomanEmpireParsedGameData): void {
        if (data?.bothWayWins?.length) {
            //data.bothWayWins[0].lineStart = "right"; //only for testing
            this._betWinsData = data.betWins?.concat(data.bothWayWins);
        }
    }
}

